import React from 'react';
import error from '../../Images/error.jpg'

function Error() {
  return (
    <div className="error-page text-center mt-5">
      <h1>We'll be back soon!</h1>
      <img src={error} className='img-fluid'/>
      <p>Sorry for the inconvenience but we're performing some construction at the moment.</p>
      <p>We'll be back online shortly!</p>
      <p>&mdash; Vilvattam Service Bank Team</p>
    </div>
  );
}

export default Error;
